<template>
    <div class="modal fade modal-upload" id="resetSecretKeyUser" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog">
            <div class="modal-content">

                <div v-show="(loading == true)" class="loading-backdrop">
                    <div class="loading"></div>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>

                    <div class="center-modal ex-input-center">

                        <div class="center-ttl font300 d-flex justify-content-center">
                            <i class="icon-user mr-2 mt-1"></i>
                            <span class="font500 text-pink">
                                {{ $t('user.reset_secret_key.title') }}
                            </span>
                        </div>

                        <div class="error-message" v-if="alert_error" data-vv-scope='s1'>
                            <div class="d-flex">
                                <i class="icon-warning mr-2"></i>
                                <div class="errror-txt">
                                    <p class="fs-14 text-red font600">{{ $t('error.title') }}</p>
                                    <p class="fs-14 text-red font600">{{ alert_error }}</p>
                                </div>
                            </div>
                        </div>

                        <div v-if="this.resetSecretKeyObj.ids.length > 0" data-vv-scope='s2'>
                            <div v-if="(listReset == null) && (init == true)" data-vv-scope='s3'>

                                <div class="d-flex justify-content-center">
                                    <div class="pr-2 w-165">
                                        <button class="btn btn-pink-53 w-100" :disabled="disabled" @click="resetSecretKeyUsers" ref="buttonResetSecretKeyUsers" type="button">
                                            {{ $t('button.ok') }}
                                        </button>
                                    </div>

                                    <div class="pl-2 w-165">
                                        <button class="btn btn-gray-53 w-100" :disabled="disabled" data-dismiss="modal" type="button">
                                            {{ $t('button.cancel') }}
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
/* global $ */
import UserManagementService from '@/services/admin/user.service';
import Utils from '@/helpers/utils';
import store from '@/store/index';

export default {
    name: 'resetSecretKeyManagement',
    props: {
        resetSecretKeyObj: [Object],
    },
    data () {
        return {
            alert_success: "",
            alert_error: "",

            loading: false,
            disabled: false,

            init: true,
            lists: null,
        };
    },
    beforeCreate () {
        this.$forceUpdate();
    },
    created () {
        this.resetModal();
    },
    beforeMount () {
    },
    mounted () {
        let _this = this;
        $("#resetSecretKeyUser").on('show.bs.modal', function () {
            store.commit('loading', false);
        });
        $("#resetSecretKeyUser").on('hide.bs.modal', function () {
            _this.resetModal();
            store.commit('loading', false);
        });
    },
    computed: {
        listReset: function () {
            this.$forceUpdate();
            if (this.lists && this.lists.length > 0) {
                let _list = [];
                $.each(this.lists, function (key, value) {
                    let item = {
                        id: value.id,
                        full_name: value.full_name,
                        password: value.password,
                        group_name: value.group_name,
                        username: value.username,
                        role_name: value.role_name,
                        valid_period_from: value.valid_period_from,
                        valid_period_to: value.valid_period_to,
                        mfa_registered: value.mfa_registered,
                    };
                    _list.push(item);
                });
                return _list;
            } else {
                return null;
            }
        },
    },
    watch: {
    },
    methods: {
        resetSecretKeyUsers: function resetSecretKeyUsers (event) {
            if (this.resetSecretKeyObj.ids.length < 0) {
                return false;
            }

            this.loading = true;
            this.disabled = true;

            UserManagementService.resetSecretKeyUser(this.resetSecretKeyObj.ids)
                .then(response => {
                    if (response[0].status == 200) {
                        if (response[0].data) {
                            this.lists = response[0].data;
                            this.init = false;
                            this.$emit('updateListUser');
                            this.$emit('unSlectAllUser');
                            $('#resetSecretKeyUser').modal('hide');
                            $('.modal-backdrop').remove();
                        }

                        this.alert_success = this.$t('success.reset_secret_key_success');
                        this.alert_error = "";

                        this.$toasted.success(this.alert_success, {icon: 'fa-check'});
                    } else {
                        this.alert_success = "";
                        this.alert_error = this.$t('fail.reset_secret_key_fail');

                        let errorCode = Utils.getErrorCode(response[0]);
                        if (errorCode) {
                            this.alert_error = this.$t('error.error_code_' + errorCode);
                        }

                    }

                    this.loading = false;
                    this.disabled = false;

                }).catch(error => {
                    this.alert_success = "";
                    this.alert_error = this.$t('fail.reset_secret_key_fail');
                    this.loading = false;
                    this.disabled = false;
                });

            return false;
        },

        resetModal: function resetModal () {
            this.loading = false;
            this.disabled = false;
            this.init = true;
            this.lists = null;

            this.alert_success = "";
            this.alert_error = "";
        },

        closeModal: function resetModal () {
            this.$emit('unSlectAllUser');
            $("#resetSecretKeyUser").modal('hide');
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/admin/UserManagement/ResetSecretKey.vue